export const selectSurveys = (state) => state.surveys.items;
export const selectActualSurvey = (state) => state.surveys.items[0];
export const selectOldSurveys = (state) => state.surveys.items.slice(1);
